import { Injectable } from '@angular/core';
import { TimeSlot, TimeSlots } from '@checkout/const';
import { Store, select } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { CheckoutActions } from '../store/actions';
import { StateWithCustomCheckout } from '../store/checkout-state';
import { CheckoutSelectors } from '../store/selectors';

@Injectable({
  providedIn: 'root',
})
export class TimeSlotsFacade {
  constructor(private store: Store<StateWithCustomCheckout>) {}

  getTimeSlots(): Observable<TimeSlots> {
    return this.store.pipe(select(CheckoutSelectors.getTimeSlots));
  }

  getTimeSlotsState(): Observable<StateUtils.LoaderState<TimeSlots>> {
    return this.store.pipe(select(CheckoutSelectors.getTimeSlotsState));
  }

  getCurrentTimeSlot(): Observable<TimeSlot> {
    return this.store.pipe(select(CheckoutSelectors.getActiveTimeSlot));
  }

  setTimeSlot(timeSlot?: TimeSlot): void {
    this.store.dispatch(new CheckoutActions.SetTimeSlotsMode(timeSlot));
  }

  resetTimeSlots(): void {
    this.store.dispatch(new CheckoutActions.TimeSlotsReset());
  }

  getLoading(): Observable<boolean> {
    return this.store.pipe(select(CheckoutSelectors.getTimeSlotsLoading));
  }
}
